// Big npm libraries (exceljs, html2pdf, jspdf, pdf-lib) live in their own
// lazy chunks and download at the moment they're first used. On ship wifi a
// single dropped fetch used to fail the whole action with Safari's bare
// "TypeError: Load failed" (Aaron's Judee export, feedback 00e4ad1c). This
// wraps the import: the module promise is cached on success, a FAILURE is
// never cached (a fresh attempt refetches), two retries with backoff ride
// out a blip, and the final error names the action in plain words.
export function makeLazyLoader(importer, failMessage) {
  let cached = null;
  async function load() {
    for (let attempt = 1; ; attempt++) {
      try {
        if (!cached) cached = importer();
        return await cached;
      } catch {
        cached = null;
        if (attempt >= 3) {
          throw new Error(
            failMessage +
            " Try again in a moment; if it keeps failing, reload the portal once and retry."
          );
        }
        await new Promise((r) => setTimeout(r, 1200 * attempt));
      }
    }
  }
  // Fire-and-forget: start the download while the connection that just
  // loaded the page is still known-good.
  load.warm = () => { load().catch(() => {}); };
  return load;
}
